import React from 'react';
import { IGrade } from '../../../Types/IGrade';
import { useAppSelector } from '../../../Redux/Store/Store';
import styles from './GradeDisplay.module.css';

type GradeDisplayProps = {
  grade?: IGrade;
  size?: 'small' | 'medium' | 'large';
};

const GradeDisplay: React.FC<GradeDisplayProps> = ({ grade, size = 'small' }) => {
  // Get questionnaire data directly from Redux store
  const { questionnaire } = useAppSelector(state => state.questionnaire);

  // If no grade is provided, don't render anything
  if (!grade) {
    return null;
  }

  // Normalize the grade value to handle potential case mismatches
  const normalizedGrade = typeof grade === 'string' ? grade.trim() : grade;

  // Check if the grade is effectively "Not Set"
  const isNotSet = !normalizedGrade || 
                   normalizedGrade.toLowerCase() === 'not set' || 
                   normalizedGrade.toLowerCase() === 'notset' ||
                   normalizedGrade === '';

  // Get colors from questionnaire.gradeOptions
  const getGradeColors = (): { backgroundColor: string; color: string } => {
    if (questionnaire?.gradeOptions) {
      const gradeOption = questionnaire.gradeOptions.find(
        option => option.value === normalizedGrade || option.text === normalizedGrade
      );
      
      if (gradeOption) {
        return {
          backgroundColor: gradeOption.colour || '#6c757d',
          color: gradeOption.textColour || '#ffffff'
        };
      }
    }
    
    // Default fallback if no grade options found
    return {
      backgroundColor: '#6c757d',
      color: '#ffffff'
    };
  };

  const colors = getGradeColors();

  if (isNotSet) {
    return (
      <div 
        className={`${styles.gradeDisplay} ${styles[size]}`}
        style={{ 
          backgroundColor: colors.backgroundColor,
          color: colors.color
        }}
      >
        -
      </div>
    );
  }

  return (
    <div 
      className={`${styles.gradeDisplay} ${styles[size]}`}
      style={{ 
        backgroundColor: colors.backgroundColor,
        color: colors.color
      }}
    >
      {normalizedGrade}
    </div>
  );
};

export default GradeDisplay;
